module.exports = __webpack_public_path__ + "static/media/socotab.88970b76.jpg";